/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ acreage: NonNullable<unknown> }} Care_Log_Area_AcreageInputs */

const vi_care_log_area_acreage = /** @type {(inputs: Care_Log_Area_AcreageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.acreage} m²`)
};

/**

* @param {Care_Log_Area_AcreageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_area_acreage = /** @type {((inputs: Care_Log_Area_AcreageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Area_AcreageInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_area_acreage(inputs)
});